// Zdarzenia sztuk z bramy (SSE `zdarzenie`: alarmy, przebiegi) dla ekranów, które na nie czekają (lista alarmów
// odświeża się przy `alarm.changed`). Słuchacze per rodzaj; brak słuchacza = zdarzenie pominięte.
import type { DaneZdarzen, StreamEvent } from "../gen/kontrakt";

type Rodzaj = keyof DaneZdarzen;
type Sluchacz = (e: StreamEvent) => void;

const sluchacze = new Map<Rodzaj, Set<Sluchacz>>();

export function przyjmijZdarzenie(e: StreamEvent): void {
  for (const f of sluchacze.get(e.rodzaj) ?? []) f(e);
}

/** Słucha zdarzeń rodzaju; zwraca odpięcie (do useEffect). */
export function naZdarzenie(rodzaj: Rodzaj, f: Sluchacz): () => void {
  let z = sluchacze.get(rodzaj);
  if (!z) sluchacze.set(rodzaj, (z = new Set()));
  z.add(f);
  return () => {
    z.delete(f);
  };
}
